export const selectStylesLigth = {
    menu: (provided) => ({
        ...provided,
        zIndex:999,
        borderRadius: "10px", // Заокруглення меню
        overflow: "hidden", // Щоб кути не виходили за межі
      }),

    menuList: (provided) => ({
        ...provided,
        borderRadius: "10px", // Заокруглення внутрішнього списку
    }),

    valueContainer: (provided) => ({
        ...provided,
        gap: "0.25rem",
        paddingLeft: "0.45rem",
        paddingRight: "0.45rem",
        paddingTop: "0.15rem",
        paddingBottom: "0.15rem",
    }),

    multiValue: (provided) => ({
        ...provided,
        backgroundColor: "#4680FF",
        borderRadius: "8px",
        padding: '0px 0px 0px 5px',
        margin: "0.1rem 0",
        alignItems: "center",
    }),

    multiValueLabel: (provided) => ({
        ...provided,
        color: "#fff",
        fontSize: "0.75rem",
        fontWeight: 500,
        padding: "8px 6px 8px 12px",
        lineHeight: 1.2,
    }),

    multiValueRemove: (provided) => ({
        ...provided,
        color: "#fff",
        borderRadius: "8px",
        padding: "8px 12px 8px 2px",
        cursor: "pointer",
        ":hover": {
            backgroundColor: "rgba(0, 123, 255, 0.25)",
            color: "#fff",
        },
    }),
    singleValue: (provided) => ({
        ...provided,
        color: "#131920", // Колір вибраного елемента
      }),
    control: (base, state) => ({
        ...base,
        caretColor: "transparent",
        width: "100%",
        padding: "0.1rem",// "0.3rem 0.2rem",
        fontSize: "0.875rem",
        fontWeight: 400,
        lineHeight: 1.5,
        color:"#131920",
        backgroundColor: "#fff",
        border: "1px solid #bec8d0",
        borderRadius: "8px",
        transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        appearance: "none",
        backgroundClip: "padding-box",
        boxShadow: state.isFocused ? "0 0 0 3px rgba(0, 123, 255, 0.25)" : "none",
        borderColor: state.isFocused ? "#007bff" : "#bec8d0",
        "&:focus": {
            
        },
        "&:hover": {
                
            backgroundColor: "#F8F9FA",
        },

        
    }),

    
    option: (provided, state) => ({
        ...provided,
        
        fontWeight:500,
        fontSize:14,
        backgroundColor: state.isSelected ? "#DEEBFF" : "white",
        color: state.isSelected ? "#131920" : "#131920",
        "&:hover": {
            backgroundColor: "#DEEBFF",
            color: "#131920",
        },
    })    
}
     
 
export const selectStylesDark = {
    menuList: (provided) => ({
        ...provided,
        borderRadius: "10px", // Заокруглення внутрішнього списку
    }), 

    valueContainer: (provided) => ({
        ...provided,
        gap: "0.25rem",
        paddingLeft: "0.45rem",
        paddingRight: "0.45rem",
        paddingTop: "0.15rem",
        paddingBottom: "0.15rem",
    }),

    multiValue: (provided) => ({
        ...provided,
        backgroundColor: "#4680FF",
        borderRadius: "8px",
        padding: 0,
        margin: "0.1rem 0",
        alignItems: "center",
    }),

    multiValueLabel: (provided) => ({
        ...provided,
        color: "#fff",
        fontSize: "0.75rem",
        fontWeight: 500,
        padding: "8px 6px 8px 12px",
        lineHeight: 1.2,
    }),

    multiValueRemove: (provided) => ({
        ...provided,
        color: "#fff",
        borderRadius: "8px",
        padding: "8px 12px 8px 2px",
        cursor: "pointer",
        ":hover": {
            backgroundColor: "rgba(0, 123, 255, 0.25)",
            color: "#fff",
        },
    }),
    singleValue: (provided) => ({
        ...provided,
        color: "#bfbfbf", // Колір вибраного елемента
      }),   
    control: (base, state) => ({
        ...base,
        caretColor: "transparent",
         
        width: "100%",
        padding: "0.1rem", // "0.4rem 0.36rem",
        fontSize: "0.875rem",
        fontWeight: 400,
        lineHeight: 1.5,
        
        backgroundColor: "#263240",
        border: "1px solid #303f50",
        borderRadius: "8px",
        transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        appearance: "none",
        backgroundClip: "padding-box",
        boxShadow: state.isFocused ? "0 0 0 3px rgba(0, 123, 255, 0.25)" : "none",
        borderColor: state.isFocused ? "#007bff" : "#bec8d0",
        "&:focus": {
            
        },
        "&:hover": {
                
            backgroundColor: "#263240",
        },

        
    }),

    input: (base) => ({
        ...base,
        color: "#BFBFBF", // 🎨 Колір тексту, який вводиться
        fontWeight: "500", // (Необов'язково) Робимо текст жирним
    }),

    menu: (base) => ({
        ...base,
        zIndex:9999,
        borderRadius: "10px", // Заокруглення меню
        overflow: "hidden", // Щоб кути не виходили за межі
        backgroundColor: "#263240", // 🎨 Фон випадаючого списку
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    }),

    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? "#1B232D" : "#263240",
        color:"#BFBFBF",
        //color: state.isSelected ? "white" : "black",
        "&:hover": {
            backgroundColor: "#283544",
            //color: "black",
        },
    }),

    noOptionsMessage: (provided) => ({
        ...provided,
        color: "#98a2b3",
    }),

    placeholder: (provided) => ({
        ...provided,
        color: "#98a2b3",
    }),
}
    